import whatInput from "what-input";
// Import SCSS (processed by Vite)
import "../scss/app.scss";

var $ = jQuery;
window.$ = $;

import Foundation from "foundation-sites";
// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
//import './lib/foundation-explicit-pieces';
//import './lib/custom-map';
import "./lib/menu";
import "./lib/slick";
import "./lib/map";
import "./lib/modal";
import "./lib/video";
import { general } from "./lib/general";

$(document).foundation();
general();
